import React from 'react';
import CenterFlexBox from 'components/CenterFlexBox';
import { Button } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import html2canvas from 'html2canvas';
import { badge, signature } from './constants';


function Certificate({details, ...props}) {
  const ref = React.useRef();

  const [data, setData] = React.useState(details);

  React.useEffect(()=>{
    setData(details);
  },[details])

  const captureScreenshot = async () => {
    html2canvas(ref.current).then(function (canvas) {
      const a = document.createElement('a');
      a.href = canvas.toDataURL();
      a.download = 'certificate.png';
      a.click();
    });
  };

  return (
    <CenterFlexBox width={842} height={595} overflow='hidden'>
      {data && (
        <div style={{
          display: 'flex', justifyContent: 'flex-end', alignItems: "center",
          padding: "8px 32px", position: "fixed", top: 0, right: 0, left: 0,
        }}>
          <Button
            startIcon={<FileDownloadOutlinedIcon />}
            onClick={captureScreenshot}
            style={{ textTransform: 'capitalize', padding: '8px 15px', fontSize: '16px' }}
            variant="contained"
          >
            Download Certificate
          </Button>
        </div>
      )}
      {data && (<div
        ref={ref}
        id="certificate"
        style={{
          background: "linear-gradient(128.38deg, #60B3FF 0%, #161BA0 111.86%)",
          overflow: "hidden", position: "relative",
          flexShrink: 0,
          flexGrow: 0,
          width: 842,
          height: 595,
          minWidth: 'fit-content',
          minHeight: 595,
        }}
      >
        <div
          style={{
            position: 'absolute', width: "473px", height: '175.25px',
            left: '-177px', top: '-13px', background: 'rgb(96, 179, 255)',
            transform: 'rotate(-30deg)'
          }}
        />
        <div
          style={{
            position: 'absolute', width: "473px", height: '175.25px',
            left: '-180px', top: '-45px', transform: 'rotate(-30deg)',
            background: 'linear-gradient(268.56deg, rgb(96, 179, 255) -0.76%, rgb(16, 97, 245) 76.47%)',
          }}
        />
        <div style={{
          boxSizing: 'border-box', position: 'absolute', width: "274px",
          height: '101.63px', left: '-154px', top: '13px', borderWidth: '4px',
          transform: 'rotate(-30deg)', borderStyle: 'solid',
          borderColor: '#49b5ea'
        }} />
        <div id='badgeDiv' 
          style={{ 
            position: "absolute",
            right: 20, top: 10,
            zIndex: 100,
          }}
          dangerouslySetInnerHTML={{__html: badge }}>
        </div>
        <div
          style={{
            zIndex: 5, position: "absolute", width: "730px",
            height: "490px", left: "56px", top: "52px",
            background: "linear-gradient(160.86deg, #CBE6FF -73.01%,#FFFFFF 87.12%)",
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="730" height="490" viewBox="0 0 730 490" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M712 0H694V19H0V37H694V490H712V37H730V19H712V0Z" fill="url(#paint0_linear_5952_28738)"/>
          <defs>
          <linearGradient id="paint0_linear_5952_28738" x1="284.5" y1="-113" x2="561.5" y2="576.5" gradientUnits="userSpaceOnUse">
          <stop stop-color="#1061F5"/>
          <stop offset="1" stop-color="#48DEDD"/>
          </linearGradient>
          </defs>
          </svg>
          {/* Content */}
          <div style={{
            display: "flex", flexDirection: "column", alignItems: "flex-start",
            padding: "0px", gap: "4px", position: "absolute", width: "100px",
            height: "48px", left: "40px", top: "73px",
          }}>

          <svg xmlns="http://www.w3.org/2000/svg" width="174" height="59" viewBox="0 0 174 59" fill="none">
          <path d="M119.623 16.2099V15.3109H118.695H117.39H116.027H114.722H113.823V16.9349V34.8862C113.823 35.1472 113.823 35.4082 113.794 35.6692C113.794 35.9012 113.765 36.1042 113.736 36.3072C113.533 37.7572 113.011 38.9462 112.141 39.8742C111.039 41.0922 109.444 41.7012 107.414 41.7012H107.124C105.094 41.7012 103.499 41.0922 102.397 39.8742C101.527 38.9462 101.005 37.7572 100.802 36.2782C100.773 36.0752 100.744 35.8432 100.744 35.6402C100.744 35.3792 100.715 35.1182 100.715 34.8572V16.4419V15.2819H99.8161H98.6851H97.4671H95.8431H94.915V16.1809V36.6842C94.915 38.8302 95.4081 40.6572 96.4521 42.1652C96.9451 42.9193 99.9321 46.8053 107.269 46.8053C114.548 46.8053 117.593 42.9193 118.086 42.1652C119.101 40.6572 119.623 38.8302 119.623 36.6842V16.2099C119.623 16.2389 119.623 16.2099 119.623 16.2099Z" fill="#2DABFF"/>
          <path d="M0 39.0652V44.3723V45.3873V46.3153H0.928011H2.05903H2.98704H4.93006H5.85807V45.4163V43.6763V5.5698V4.55478V3.62677H4.95906H3.07404H1.74002H0.928011H0.0290004V4.55478V5.5698L0 39.0652Z" fill="#2DABFF"/>
          <path d="M127.485 15.3433H123.454H123.425H122.555V16.2423V17.1703V43.1546V45.4746V46.4026H123.483H124.237H125.397H127.485H128.413V45.4746V44.1406V16.7063V16.2713V15.3723H127.543C127.514 15.3433 127.514 15.3433 127.485 15.3433Z" fill="#2DABFF"/>
          <path d="M33.235 19.7799C32.2489 18.2139 30.8279 16.9959 28.9719 16.1259C27.1159 15.2269 24.9408 14.7919 22.4758 14.7919C19.1988 14.7919 16.3567 15.4299 14.1527 16.9959C9.77366 20.1569 10.1217 25.551 10.1217 25.551H15.9217C15.9217 25.551 16.1537 23.318 17.2558 21.868C17.2848 21.868 17.2848 21.839 17.2848 21.81C17.3718 21.723 17.4298 21.636 17.5168 21.549C17.6038 21.462 17.6908 21.375 17.7778 21.317C18.0098 21.1139 18.2708 20.9399 18.5608 20.7659C19.6048 20.1569 20.9388 19.8379 22.6208 19.8379C24.7378 19.8379 26.3039 20.3309 27.3479 21.317C28.3919 22.303 28.9139 23.695 28.9139 25.493V27.378H21.8378C17.8648 27.378 14.7617 28.277 12.5577 30.0751C10.3247 31.8731 9.22266 34.3671 9.22266 37.5281C9.22266 40.6022 10.1797 42.9222 12.0937 44.4592C14.0077 45.9963 16.4437 46.7503 19.4018 46.7503C19.7208 46.7503 20.0108 46.7503 20.3298 46.7213C20.4748 46.7213 20.6198 46.6923 20.7648 46.6923C21.0548 46.6633 21.3448 46.6343 21.6058 46.6053C21.9538 46.5473 22.2728 46.4893 22.5918 46.4313C22.6208 46.4313 22.6498 46.4313 22.6498 46.4313C22.9398 46.3733 23.2298 46.2863 23.4908 46.2283C23.8098 46.1413 24.0708 46.0543 24.3608 45.9673C24.3898 45.9673 24.4478 45.9383 24.4768 45.9383C24.7088 45.8512 24.9408 45.7643 25.1438 45.6772C25.4049 45.5612 25.6369 45.4452 25.8399 45.3582C25.8689 45.3582 25.8979 45.3292 25.9269 45.3292C26.1009 45.2422 26.3039 45.1262 26.4779 45.0392C26.6519 44.9232 26.8259 44.8362 26.9709 44.7202C27.3479 44.4882 27.6669 44.2272 27.9569 44.0242C28.0729 43.9082 28.1889 43.8212 28.3049 43.7342C28.7109 43.3572 28.9139 43.0672 28.9139 42.9802V46.3153H34.772V25.087C34.714 23.115 34.221 21.346 33.235 19.7799ZM28.8559 35.8461C28.8559 37.5861 28.0439 39.0362 26.4489 40.1672C24.8538 41.2982 22.9688 41.8782 20.8228 41.8782C19.1118 41.8782 17.7198 41.5012 16.6467 40.7182C15.5737 39.9642 15.0227 38.8042 15.0227 37.3251C15.0227 35.6431 15.7477 34.3671 17.1688 33.4101C18.5898 32.4821 20.5038 32.0181 22.9108 32.0181H28.8849L28.8559 35.8461Z" fill="#2DABFF"/>
          <path d="M62.6419 43.6727V25.6054C62.6419 22.3284 61.6559 19.6894 59.7129 17.7753C57.7698 15.8323 55.1308 14.8753 51.7958 14.8753C51.4478 14.8753 51.0998 14.8753 50.7807 14.9043H50.7517C50.4907 14.9333 50.2297 14.9623 49.9687 14.9913C49.8817 14.9913 49.7947 15.0203 49.7367 15.0203C49.4467 15.0783 49.1857 15.1073 48.9247 15.1653C48.8957 15.1653 48.8667 15.1653 48.8667 15.1653C48.6057 15.2233 48.3737 15.2813 48.1707 15.3683C47.7067 15.5133 47.2717 15.6873 46.8657 15.8613C46.6917 15.9193 46.5467 16.0063 46.3727 16.0933C45.2707 16.7023 44.5457 17.4563 44.1687 18.0073C43.9077 18.3553 43.7917 18.6164 43.7917 18.7614V17.8623V16.1513V15.2523H42.8637H40.7466H40.6016H38.8616H37.9336V17.8623V44.1077V46.2827H39.7606H41.4426H43.7917V44.1077V25.6054C43.9947 23.8654 44.6907 22.4734 45.9087 21.4294C47.0977 20.3854 48.5767 19.8924 50.3457 19.8924C52.2888 19.8924 53.8548 20.5304 55.0438 21.7774C56.2328 23.0244 56.8128 24.6774 56.8128 26.7075V45.3547V46.2537H58.8718H60.1189H62.6419V43.6727Z" fill="#2DABFF"/>
          <path d="M91.6433 15.3139H90.7153H89.3233H87.9312H86.6842H85.7562V16.2129V17.3439V18.6489C85.7562 18.4169 85.5822 18.0689 85.2632 17.6919C85.2632 17.6919 85.2632 17.6629 85.2342 17.6629C84.7702 17.1409 84.0162 16.5029 82.9722 15.9809C82.7402 15.8649 82.4792 15.7489 82.2182 15.6619C82.1602 15.6329 82.1022 15.6039 82.0152 15.5749C81.6962 15.4589 81.3772 15.3429 81.0292 15.2559C81.0292 15.2559 81.0002 15.2269 80.9712 15.2269C80.6522 15.1399 80.3041 15.0529 79.9271 14.9949H79.8981C79.5211 14.9369 79.1441 14.8789 78.7961 14.8499C78.4481 14.8209 78.1291 14.7919 77.7521 14.7919C77.6941 14.7919 77.6361 14.7919 77.5781 14.7919C74.9101 14.7919 72.5611 15.5169 70.589 16.9959C68.617 18.4749 67.254 20.4469 66.471 22.883C65.862 24.71 65.543 27.32 65.543 30.6841C65.543 33.8451 65.804 36.3391 66.326 38.1081C67.138 40.8052 68.588 42.8352 70.734 44.2272C72.8801 45.5902 75.2581 46.2862 77.8971 46.2862C78.6511 46.2862 79.3471 46.2282 79.9851 46.1122C80.1301 46.0832 80.2751 46.0542 80.4201 46.0252C80.5941 46.0252 80.7682 45.9672 80.9132 45.9092C81.0872 45.8802 81.2902 45.8222 81.4352 45.7642C81.4932 45.7642 81.5222 45.7352 81.5512 45.7062C81.9862 45.5902 82.4212 45.4162 82.8272 45.2132C83.0012 45.1262 83.2042 45.0392 83.3492 44.9232C83.6102 44.8072 83.8132 44.6622 84.0162 44.4882C84.1322 44.4302 84.2192 44.3432 84.3352 44.2562C84.3932 44.2272 84.4512 44.1692 84.5092 44.1112C84.7122 43.9372 84.8862 43.7922 85.0022 43.6182C85.4662 43.1252 85.6692 42.6902 85.6692 42.5162V44.5172C85.6692 47.5333 84.9152 49.6793 83.4072 50.9553C81.8992 52.2313 79.4631 52.8693 76.0991 52.8693H73.1991H72.5611V58.3504H76.0991H76.2151C80.8551 58.3504 84.5672 57.2774 87.3512 55.1604C90.1353 53.0143 91.5273 49.5053 91.5273 44.6332V16.9959L91.6433 15.3139ZM85.6692 34.3381C85.6112 35.0921 85.5242 35.7591 85.4082 36.4261C85.0892 37.9341 84.3642 39.1522 83.2332 40.1092C82.1312 41.0662 80.6522 41.5302 78.8831 41.5302C77.1721 41.5302 75.7221 41.0372 74.5331 40.1092C73.3441 39.1522 72.5321 37.9341 72.126 36.4261C71.72 35.4111 71.517 33.4971 71.517 30.6841C71.517 28.132 71.749 26.247 72.184 25C72.6771 23.492 73.4891 22.274 74.6201 21.3169C75.7511 20.3599 77.1721 19.8959 78.8831 19.8959C80.5941 19.8959 82.0152 20.3889 83.1462 21.3169C84.2772 22.274 85.0312 23.492 85.3502 25C85.5242 25.638 85.6402 26.334 85.6982 27.03C85.7562 27.755 85.7852 28.944 85.7852 30.6551C85.7852 32.3951 85.7272 33.6131 85.6692 34.3381Z" fill="#2DABFF"/>
          <path d="M174 15.3396L173.652 16.3836L172.173 20.7047L163.328 46.747L162.4 49.444C161.704 51.358 161.037 52.8951 160.37 54.0551C160.225 54.3161 160.051 54.5771 159.906 54.8091C159.123 55.9401 158.166 56.8101 156.977 57.3901C156.745 57.5061 156.484 57.6221 156.252 57.7091C154.744 58.2601 152.627 58.5501 149.901 58.5501H149.031V53.6201H149.756C151.38 53.6201 152.656 53.4461 153.584 53.0691C154.512 52.6921 155.266 52.0251 155.904 51.039C156.542 50.053 157.151 48.545 157.702 46.573C157.76 46.486 157.76 46.37 157.702 46.196L149.118 20.7047H141.636V45.471C141.636 45.471 141.636 45.471 141.636 45.5V46.399H135.778V45.5C135.778 45.5 135.778 45.5 135.778 45.471V20.7047H130.848V15.3396H135.778V13.9766C135.778 11.3085 136.097 9.22052 136.735 7.7705C137.344 6.29148 138.417 5.24747 139.925 4.63846C140.853 4.26146 142.013 3.97145 143.434 3.82645C144.304 3.73945 145.232 3.71045 146.276 3.71045H149.089V8.84351H146.885C146.247 8.84351 145.667 8.87251 145.174 8.95952C144.072 9.13352 143.26 9.48152 142.738 10.0035C142.013 10.7575 141.636 12.2366 141.636 14.3826V15.3686H153.468L153.642 15.9196L153.671 16.0066L155.15 20.7337L160.312 37.2349L160.602 38.1629L160.747 38.6559L160.892 38.1629L166.199 20.7337L167.649 15.9776L167.823 15.3686L174 15.3396Z" fill="#2DABFF"/>
          <path d="M125.165 0C124.092 0 123.077 0.377005 122.265 0.986012C122.004 1.18901 121.743 1.42102 121.511 1.68202C120.815 2.52303 120.38 3.59604 120.38 4.75606C120.38 7.16309 122.178 9.16411 124.498 9.48312C126.122 7.9751 125.629 5.56807 125.368 5.04606L126.499 4.55305C127.079 5.80007 127.456 9.74412 123.193 11.6581L123.976 13.1952H124.005C127.398 11.9771 129.95 8.93211 129.95 5.10406C129.921 2.49403 127.804 0 125.165 0Z" fill="#2DABFF"/>
          </svg>

          </div>
          <div
            style={{
              position: "absolute", width: "358px", height: "36px", right: 80,
              top: "80px", fontFamily: "Montserrat", fontWeight: 600,
              fontSize: "10px", textAlign: "right", color: "#9A9FD8",
            }}
          >
            {details?.date || 'Date'}
          </div>
          <div style={{
            position: "absolute", width: "fit-content", left: "50px",
            top: "146px", fontFamily: "Montserrat", fontWeight: 700,
            fontSize: "26px", color: "#1A52F3",
          }}>
            Certificate of Completion
          </div>
          <div style={{
            display: "flex", flexDirection: "column", alignItems: "flex-start",
            position: "absolute", width: "fit-content", height: "44px",
            left: "50px", top: "200px",
          }}>
            <div style={{
              width: "fit-content", fontFamily: "Montserrat", fontWeight: 700,
              fontSize: "22px", color: "#60B3FF", textTransform: 'capitalize'
            }}>
              {data?.name || 'Name'}
            </div>
          </div>
          <div style={{
            position: "absolute", width: "fit-content", left: 50, top: 256, right: 80,
            color: "rgba(22, 27, 160, 0.55)", lineHeight: "17px",
            fontFamily: "Montserrat", fontWeight: 600, fontSize: "14px",
          }}>
            This certifies that {data?.name || 'name'} has demonstrated exceptional commitment and successfully 
            completed the Pathway to {data?.pathway} in {data?.duration ?? '(x)'} weeks, achieving an outstanding score of {data?.score ?? '(y)'}. 
            Throughout the program, {data?.name || 'name'} has displayed sincere dedication, showcasing commendable skills and 
            knowledge across all modules. This certificate is a testament to his hard work and preparedness for interviews.
          </div>
          <div style={{
            display: "flex", flexDirection: "column", alignItems: "flex-start",
            padding: "0px", gap: "6px", position: "absolute",
            width: "114px", left: "50px", top: "380px",
          }}>
            <div dangerouslySetInnerHTML={{__html: signature }}></div>
            <div style={{
              fontFamily: "Montserrat", fontWeight: 700, fontSize: "14px",
              color: "#60B3FF",
            }}>
              CEO & Founder Languify
            </div>
          </div>
        </div>
        <div style={{
          zIndex: 4,
          boxSizing: 'border-box',
          position: 'absolute',
          width: "130px",
          height: "130px",
          left: "-8px",
          top: "477px",
          transform: "rotate(-45deg)",
          borderWidth: '3px',
          borderStyle: 'solid',
          borderColor: '#52a7fd',
        }} />
        <div style={{
          zIndex: 4,
          boxSizing: 'border-box',
          position: 'absolute',
          width: "66.66px",
          height: "66.66px",
          left: "23px",
          top: "430px",
          transform: "rotate(-45deg)",
          borderWidth: '3px',
          borderStyle: 'solid',
          borderColor: '#53a8fd',
        }} />
        <div style={{
          zIndex: 4,
          boxSizing: 'border-box',
          position: 'absolute',
          width: "66.66px",
          height: "66.66px",
          left: "133px",
          top: "509px",
          transform: "rotate(-45deg)",
          borderWidth: '3px',
          borderStyle: 'solid',
          borderColor: '#49b6ea',
        }} />
        <div style={{
          position: "absolute",
          width: "473.47px",
          height: "175.25px",
          right: "-44px",
          bottom: "-152px",
          background: "#4A84F9",
          transform: "rotate(-30deg)",
        }} />
        <div style={{
          zIndex: '6',
          boxSizing: 'border-box',
          position: 'absolute',
          width: "274.57px",
          height: '101.63px',
          right: '-36px',
          bottom: '0px',
          transform: 'rotate(-30deg)',
          borderWidth: '4px',
          borderStyle: 'solid',
          borderColor: '#48bde7',
        }} />
        <div style={{
          zIndex: '1',
          position: 'absolute',
          width: "473.47px",
          height: '175.25px',
          right: '-205px',
          bottom: '-105px',
          background: 'linear-gradient(268.71deg, rgb(74, 132, 249) -0.89%, rgb(5, 72, 251) 124.54%)',
          transform: 'rotate(-30deg)'
        }} />

      </div>)}
    </CenterFlexBox >
  );
}

export default Certificate;
